import { render, staticRenderFns } from "./ContainerDocuments.vue?vue&type=template&id=73786734&"
import script from "./ContainerDocuments.vue?vue&type=script&lang=js&"
export * from "./ContainerDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ContainerDocuments.vue?vue&type=style&index=0&id=73786734&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports